var x_dialog = function () {},
	x_modals_count = 0;
x_dialog.prototype = {
	modal: {
		show: function (data, url) {
			var me = this;

			$.ajax({
				url: url,
				data: data,
				method: 'POST',
				async: false,
				success: function (response) {
					//console.log(data);
					
					me.render(response, data.backdrop);
					xlisteners.init();
				}
			});
		},
		close: function () {
			$('div.modal:last').modal('hide');
		},
		render: function (content, backdrop) {
			var me = this,
				content = $(content);
			if($('.modal').length > 0 && $('.modal').find('.xmodal-drawer').length > 0) {
				var win = $('.modal').find('div.xmodal-drawer');
				win.empty();
				
				var content = $(content).find('div.xmodal-drawer').children();
				win.append(content);

				
				loadingbar.stop();
				return;
			} else {
				var mod = $(content).appendTo('body'),
				id = mod.attr('id');
			}
			
			mod.on('hidden.bs.modal', function (e) {
				var last = $('div.modal:last').attr('id');

				if (id == last) {
					mod.remove();
					x_modals_count--;
				}
				//debugger;
				if (x_modals_count > 0) {
					$('div.modal:last').modal('show');
				}
			});

			mod.on('show.bs.modal', function (e) {
				if (x_modals_count > 1) {
					$('div.modal:not(:last)').modal('hide');
				}
			});

			x_modals_count++;
			mod.modal({
				backdrop: backdrop !== undefined ? backdrop : 'static', // 'static' | true | false
				keyboard: true,
				show: true,
				remote: false
			});

			$(document).one('keydown', function(e) {
				if(e.keyCode === 27) {
					$('div.modal').modal('hide');
				}
			});
		}
	},
	notify: {
		show: function (title, text, type, callback) {
			//debugger;
			switch (type) {
				case 'success':
					var obj = {
						//toast: true,
						//position: 'top-center',
						type: 'success',
						html: text,
						title: title,
						showConfirmButton: false,
						timer: 1000,
						heightAuto: false

					};
					break;
				case 'info':
					var obj = {
						type: 'info',
						html: text,
						title: title,
						confirmButtonText: 'Supratau'
					};

					break;
				case 'warning':
					var obj = {
						type: 'warning',
						html: text,
						title: title
						//timer:1000
					};
					break;
				case 'danger':
					//text = ((typeof text == 'object') ? text[0] : text);
					var obj = {
						type: 'error',
						html: text,
						title: title,
						confirmButtonColor: '#d33',
						confirmButtonText: 'Supratau'
					};
					break;
				case 'loading':
					//text = ((typeof text == 'object') ? text[0] : text);
					var obj = {
						type: 'info',
						html: text,
						title: title,
						allowOutsideClick: false,
						confirmButtonColor: '#d33',
						confirmButtonText: 'Atšaukti'
					};
					break;
				default:
					var timer = 1000;
					break;
			};

			if (callback === undefined) {
				Swal.fire(obj);
				return;
			}
			loadingbar.stop();
			Swal.fire(obj).then(callback);
		},
		close: function () {
			Swal.close();
		}
	},
	question: {
		show: function (config, callback) {
			var defaults = {
				type: 'question',
				title: 'Ar tikrai norite?',
				text: 'Šio veiksmo atšaukti negalėsite!',
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				confirmButtonText: 'Taip',
				cancelButtonText: 'Ne',
				heightAuto: false
			};

			$.extend(defaults, config);

			Swal.fire(defaults).then(function (answer) {
				// callback((answer.dismiss == 'cancel') ? false : true);
				// answer turi kelis `dismiss` tipus: `cancel`, `overlay` - mums svarbu tik, kai patvirtino
				callback((answer.value ? true : false));
			});
		}
	},
	close: function () {

	},
	tooltip: {
		show: function (element, tooltip, style) {
			element.tooltipster({
				content: tooltip || element.data('tooltip') || element.attr('title'),
				contentAsHTML: true,
				interactive: true,
				delay: element.data('delay') || 300
			});
		},
		remote: function (element, url, data, conf) {
			if (element.hasClass('tooltipstered')) {
				return;
			}

			xcrud.load(url, data, function (html) {
				let config = {
					content: html,
					contentAsHTML: true,
					interactive: true
					//...conf
				};

				//console.log(config);

				element.tooltipster(config).tooltipster('open');
			});
		}
	},
	bar: {
		show: function (config) {
			let $element = $(this);

			let $xtoast = $("<div class='xtoast'></div>");

			// Default attributes
			let defaults = {
				type         : "success",
				message      : "This is an xtoast message!",
				textColor    : '#FFFFFF',
				duration     : 1500,
				speed        : 500,
				callback     : function () {}
			};

			// Flat UI Themes
			let themes = {
				success : "#2ecc71",
				danger  : "#e74c3c",
				info    : "#3498db"
			};

			// Extend user settings
			let attributes = $.extend(defaults, config);

			// Define message
			let $message = $('<span class="xtoast-message">' + attributes.message + '</span>');
		
			// Append message to toast
			$xtoast.append($message);
		
			// xToast Styling
			$xtoast.css(
				{
					"background-color": themes[attributes.type], 
					"color": attributes.textColor
				}
			);
		
			$('body').append($xtoast);
		
			$xtoast.slideDown(attributes.speed, function() {}).delay(attributes.duration).slideUp('slow');
		}
	},
	toast: {
		show: function(title = 'Lexita labas', type = 'success', position = 'top-end', showBtn = false, callback) {
			const Toast = Swal.mixin({
				type: type,
				title: title,
				toast: true,
				position: position,
				showConfirmButton: false,
				timer: 1500
			});

			Toast.fire({}).then(()=> {
				if(typeof callback === 'function') {
					callback();
				}
			});
		}
	},
	box: {
		show: function(element) {
			let id = '_' + Math.random().toString(36).substr(2, 9);

			xcrud.load('/clients/fast_edit',
			null,
			response => {
				let el = `<div class="arrow_box" id="${id}">${response}</div>`,
					position = element.position();
				element.after(el);
				$('#' + id).css({top: position.top + 40, left: position.left});

				// Listeners init
				xlisteners.init();
				//Stop bubling after document click event
				$('#' + id).on('click', function(e) {
					e.stopPropagation();
				});
			});


			// let data = me.data(),
			// cache = false;

			// // Add event listener to show or hide
			// $(me).on('click', function(e) {
			// e.stopPropagation();

			// $('.arrow_box.--rendered').not($(data.boxid)).removeClass('--rendered').hide();

			// // Check if another boxes are opened 
			// if($(data.boxid).is(':hidden')) {
			// 	$(data.boxid).addClass('--rendered').fadeIn('fast').show();
			// } else {
			// 	$(data.boxid).removeClass('--rendered').hide();
			// }

			// // Chache template and fetch html from template
			// if(!cache) {
			// 	xcrud.load(
			// 	'../../php/modal/tooltip.php',
			// 	{
			// 		pk: data.pk,
			// 		fk: data.fk,
			// 		tooltip: data.url
			// 	},
			// 	response => {
			// 		$(data.boxid).html(response);
			// 		xlisteners.init();
			// 		cache = true;
			// 	}
			// 	);
			// }

			// $(document).on('click', function(e) {
			// 	$('.arrow_box').removeClass('--rendered').hide();
			// });

			// });

			//Stop bubling after document click event
			// $('#' + id).on('click', function(e) {
			// 	e.stopPropagation();
			// });
		},
		destroy: function() {
			$('.arrow_box').remove();
		}
	}
}

var xdialog = new x_dialog();